/* eslint-disable jsx-a11y/alt-text */
import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import Title from '@cashew/title';
import Box from '@cashew/box';
import List from '@cashew/list';
import Pagination from '@cashew/pagination';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import cn from 'classnames';
import { Button, PageWithNavigation, Tag } from '../../components';
import { MerchantData } from '../MerchantOnboarding/util';
import OrdersFilter from './OrdersFilter';
import './index.css';

const { dateFormat, priceFormat } = require('@cashew/utils');

const ns = 'risk';

const RiskItem = ({ data, selected, t }: any) => {
  const isSelected = selected === data.id;

  return (
    <div
      className={cn(`${ns}__row`, { [`${ns}__row--selected`]: isSelected })}
      role="row"
      tabIndex={0}
      onKeyDown={undefined}
    >
      <div className="three-dots">{data.merchantName || t('filed.empty')}</div>
      <div>{data.merchantId}</div>
      <div>
        {priceFormat({
          currency: data.currency || 'AED',
          amount: data.maxOrderAmount,
        })}
      </div>
      <div>{data.maxCustomerAge}</div>
      <div className="nationality">
        <div>{data.nationality}</div>
      </div>
      <div>
        <Tag status={data.isActive ? 'success' : 'error'}>
          {data.isActive ? 'Active' : 'Inactive'}
        </Tag>
      </div>
      <div>{data.createdAt ? dateFormat({ date: data.createdAt }) : ''}</div>
    </div>
  );
};

/**
 * Refunds Page RefundPage
 */
export default () => {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  const [merchants, setMerchants] = useState<MerchantData[]>([]);
  const [records, setRecords] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [showFilter, setShowFilter] = useState(false);

  return (
    <div className={ns}>
      <Helmet>
        <title>Risk rules</title>
      </Helmet>
      <PageWithNavigation>
        <Title>
          <span>Risk rules</span>
          <span>
            <Button
              extraClass="blue show-filter-btn"
              onClick={() => setShowFilter(!showFilter)}
            >
              <div className="btn-with-icon">
                <img src="/fillter.svg" />
                Filters
              </div>
            </Button>
          </span>
        </Title>

        <div className={cn({ 'hide-filter': !showFilter })}>
          <OrdersFilter
            setLoading={setIsLoading}
            useSelector={useSelector}
            page="orders"
            type="cashew"
            setRecords={setRecords}
            setList={setMerchants}
            pageSize={pageSize}
            pageNumber={pageNumber}
            history={history}
            dispatch={dispatch}
            setPageNumber={setPageNumber}
            records={records}
          />
        </div>
        <Box withHeader className={`${ns}__box`}>
          <div>
            <div className={`${ns}__headers`}>
              <p>Merchant name</p>
              <p>Merchant ID</p>
              <p>Max order value</p>
              <p>Max age value</p>
              <p>
                <span style={{ paddingRight: '1rem' }}>Nationality</span>
              </p>
              <p>Status</p>
              <p>Activation Date</p>
            </div>
            <List
              component={RiskItem}
              data={merchants}
              t={t}
              // context="merchants"
              isOffline
              isLoading={isLoading}
            />
            <Pagination
              records={records}
              pageSize={pageSize}
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
              changePageSize={setPageSize}
            />
          </div>
        </Box>
      </PageWithNavigation>
    </div>
  );
};
